import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mpacs",
  "use": "icon-mpacs-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol viewBox=\"0 0 20 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mpacs\">\r\n<path d=\"M17.9087 0.236816H7.40867H6.11292V1.53256V2.82831H0.795898V21.2368H13.9767V18.6006H17.9087H19.2044V17.3049V1.57724V0.281497L17.9087 0.236816ZM17.9087 17.3496H13.9767V2.87299H7.40867V1.57724H17.9533L17.9087 17.3496Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol